module.exports = __webpack_public_path__ + "static/media/Book-Appointment-Icon-Black.fd25cc4d.svg";